<template>
  <div class="wrap-dashboard">
    <div class="wrap-content">
      <div class="title-page">Deposit Detail</div>
      <div v-if="deposit_type == 'onexchange'">
        <deposit-detail-temp
          :detailDeposit="depositDetail"
          :detailMetalItem="detailItemMetal"
          @updateModal="modalOpen"
        ></deposit-detail-temp>

        <div class="wrap-button">
          <div v-show="(role == 2 || role == 3) && dataDetail.status == '003'">
            <b-button class="ml-2" variant="success" @click="processDeposite">
              <span v-show="!loadingDeposite">Process</span>
              <b-spinner
                label="Loading..."
                variant="light"
                small
                v-show="loadingDeposite"
              ></b-spinner>
            </b-button>
          </div>

          <div v-show="role == 5 && dataDetail.status == '001'">
            <b-button class="ml-2" variant="success" @click="processDeposite">
              <span v-show="!loadingDeposite">Process</span>
              <b-spinner
                label="Loading..."
                variant="light"
                small
                v-show="loadingDeposite"
              ></b-spinner>
            </b-button>
          </div>
        </div>
        <b-modal ref="add-attactment" title="Add Attachment">
          <form enctype="multipart/form-data" class="form-attachment">
            <div class="form-group">
              <label for="customs-doc" class="label-form"
                >Customs Documentation</label
              >
              <label class="upload-video">
                <span v-if="!loadDataCustomDoc">
                  <b-icon icon="upload" class="mr-1 icon-upload"></b-icon>
                  Choose File
                </span>
                <b-spinner small variant="ligth" v-else></b-spinner>
                <input
                  type="file"
                  accept="image/*, application/pdf"
                  ref="customsDoc"
                  @change="onCustomDoc"
                />
              </label>
              <span id="imageName" class="ml-3"> {{ label_custom }}</span>
              <div v-if="$v.form_attachment.customs_doc.$error">
                <span
                  v-if="!$v.form_attachment.customs_doc.required"
                  class="error"
                  >File required</span
                >
              </div>
            </div>
            <div class="form-group">
              <label for="invoice" class="label-form"
                >Commercial Invoice & Packing List</label
              >
              <label class="upload-video">
                <span v-if="!loadDataInvoice">
                  <b-icon icon="upload" class="mr-1 icon-upload"></b-icon>
                  Choose File
                </span>
                <b-spinner small variant="ligth" v-else></b-spinner>
                <input
                  type="file"
                  accept="image/*, application/pdf"
                  ref="invoice"
                  @change="onInvoice"
                />
              </label>
              <span id="imageName" class="ml-3"> {{ label_invoice }}</span>
              <div v-if="$v.form_attachment.commercial_invoice.$error">
                <span
                  v-if="!$v.form_attachment.commercial_invoice.required"
                  class="error"
                  >File required</span
                >
              </div>
            </div>
            <div class="form-group">
              <label for="manufacturing" class="label-form"
                >Manufacturing Document</label
              >
              <label class="upload-video">
                <span v-if="!loadDataManu">
                  <b-icon icon="upload" class="mr-1 icon-upload"></b-icon>
                  Choose File
                </span>
                <b-spinner small variant="ligth" v-else></b-spinner>
                <input
                  type="file"
                  accept="image/*, application/pdf"
                  ref="manufactur"
                  @change="onManfacturing"
                />
              </label>
              <span id="imageName" class="ml-3">
                {{ label_manufacturing }}</span
              >
              <div v-if="$v.form_attachment.manufacturing_doc.$error">
                <span
                  v-if="!$v.form_attachment.manufacturing_doc.required"
                  class="error"
                  >File required</span
                >
              </div>
            </div>
            <div class="form-group">
              <label for="vault" class="label-form">Vault Document</label>
              <label class="upload-video">
                <span v-if="!loadDataVault">
                  <b-icon icon="upload" class="mr-1 icon-upload"></b-icon>
                  Choose File
                </span>
                <b-spinner small variant="ligth" v-else></b-spinner>
                <input
                  type="file"
                  accept="image/*, application/pdf"
                  ref="vault"
                  @change="onVault"
                />
              </label>
              <span id="imageName" class="ml-3"> {{ label_vault }}</span>
              <div v-if="$v.form_attachment.vault_doc.$error">
                <span
                  v-if="!$v.form_attachment.vault_doc.required"
                  class="error"
                  >File required</span
                >
              </div>
            </div>

            <div class="form-group">
              <label for="clearing" class="label-form"
                >Recomendation Document</label
              >
              <div class="content-ftz-doc">
                <div>
                  <label for="" class="label-ftz">Later Number</label>
                  <input
                    type="text"
                    name=""
                    id=""
                    placeholder="input letter number"
                    v-model="form_attachment.recommendation_doc_no"
                    class="form-input mb-2"
                  />
                </div>
                <div>
                  <label for="" class="label-ftz">Attachment</label>
                  <label class="upload-video">
                    <span v-if="!loadDataBpbatam">
                      <b-icon icon="upload" class="mr-1 icon-upload"></b-icon>
                      Choose File
                    </span>
                    <b-spinner small variant="ligth" v-else></b-spinner>
                    <input
                      type="file"
                      accept="image/*, application/pdf"
                      ref="bpBatam"
                      @change="onBpBatam"
                    />
                  </label>
                  <span id="imageName" class="ml-3"> {{ label_bpbatam }}</span>
                </div>
              </div>

              <div v-if="$v.form_attachment.recommendation_doc.$error">
                <span
                  v-if="!$v.form_attachment.recommendation_doc.required"
                  class="error"
                >
                  Input File required
                </span>
              </div>
              <div v-if="$v.form_attachment.recommendation_doc_no.$error">
                <span
                  v-if="!$v.form_attachment.recommendation_doc_no.required"
                  class="error"
                >
                  Input letter number required
                </span>
              </div>
            </div>
          </form>
          <template #modal-footer>
            <b-button class="ml-2" variant="success" @click="addAttachment">
              <span v-show="!loadingDeposite">Submit</span>
              <b-spinner
                label="Loading..."
                variant="light"
                small
                v-show="loadingDeposite"
              ></b-spinner>
            </b-button>
          </template>
        </b-modal>
      </div>

      <div v-else>
        <deposit-detail-off-temp
          :dataDetail="depositDetail"
        ></deposit-detail-off-temp>
        <div class="wrap-button">
          <div
            v-show="
              role == 2 &&
              (dataDetail.status == '001' || dataDetail.status == '007')
            "
          >
            <b-button class="ml-2" variant="success" @click="processDeposite">
              <span v-show="!loadingDeposite">Approve</span>
              <b-spinner
                label="Loading..."
                variant="light"
                small
                v-show="loadingDeposite"
              ></b-spinner>
            </b-button>
            <b-button variant="light" class="ml-3" @click="rejectDeposit">
              <b-spinner
                label="Loading..."
                small
                v-if="isRejectDeposit"
              ></b-spinner>
              <span v-else>Reject</span>
            </b-button>
          </div>

          <div v-show="role == 2 && dataDetail.status == '004'">
            <b-button
              class="ml-2"
              variant="success"
              @click="processDeposite"
              :disabled="
                depositDetail.is_complete ||
                dataDetail.attachments.event_report_doc.analysis_doc.length ==
                  0 ||
                dataDetail.attachments.event_report_doc.deposit_doc.length ==
                  0 ||
                filteredAnalysisDocuments.length == 0 ||
                filteredDepositDocuments.length == 0
              "
            >
              <span v-show="!loadingDeposite">Process</span>
              <b-spinner
                label="Loading..."
                variant="light"
                small
                v-show="loadingDeposite"
              ></b-spinner>
            </b-button>
          </div>

          <div v-show="role == 5 && dataDetail.status == '003'">
            <b-button class="ml-2" variant="success" @click="addMetalDeposit">
              <span v-show="!loadingDeposite">Process</span>
              <b-spinner
                label="Loading..."
                variant="light"
                small
                v-show="loadingDeposite"
              ></b-spinner>
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
// import pdf from "vue-pdf";
// import DepositConfirmation from "../components/DepositConfirmation.vue";
import { required } from "vuelidate/lib/validators";

import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import DepositDetailTemp from "../components/deposit/DepositDetailTemp.vue";
import DepositDetailOffTemp from "../components/deposit/DepositDetailOffTemp.vue";

export default {
  components: {
    // pdf,
    // DepositConfirmation,
    DepositDetailTemp,
    DepositDetailOffTemp,
  },
  data() {
    return {
      loadingOperatorConfirm: false,
      loadingDeposite: false,
      loadingKbi: false,
      loadingMetal: false,
      isModalOpen: false,
      isRejectDeposit: false,
      dataDetail: {},
      dataHolding: [],
      dataNasabah: [],
      pdfFile: "",
      isImage: true,
      currentPage: 1,
      perPage: 10,
      lengthData: 1,
      trade_id: [],
      metal_id: "",
      withdrawal_id: "",
      status_operator: "",
      offset: 0,
      deposit_status: "",
      deposit_type: "",
      label_custom: "",
      label_invoice: "",
      label_manufacturing: "",
      label_vault: "",
      label_clearing: "",
      label_bpbatam: "",
      label_cukai: "",
      loadDataCustomDoc: false,
      loadDataInvoice: false,
      loadDataManu: false,
      loadDataVault: false,
      loadDataClearing: false,
      loadDataBpbatam: false,
      loadDataCukai: false,
      isLoadingPreview: false,
      isLoading: false,
      //url: "https://api2-dev.ptkbi.com/v2",
      url: "https://api2-v2.ptkbi.com/v2",
      role: "",
      dataImage: [],
      numPages: undefined,
      src: null,
      isPdf: false,
      labelPreview: "",
      statusDeposit: "",
      form: {
        allocated: "",
        hub: "",
        dimension: "",
        fineness: "",
        hallmark: "",
        serial_number: "",
        year: "",
      },
      form_attachment: {
        metal_id: "",
        customs_doc: "",
        commercial_invoice: "",
        manufacturing_doc: "",
        vault_doc: "",
        clearing_doc: "",
        recommendation_doc: "",
        recommendation_doc_no: "",
        // ftz_doc: "",
        // ftz_doc_no: "",
      },
    };
  },
  validations: {
    form_attachment: {
      customs_doc: {
        required,
      },
      commercial_invoice: {
        required,
      },
      manufacturing_doc: {
        required,
      },
      vault_doc: {
        required,
      },
      // clearing_doc: {
      //   required,
      // },
      recommendation_doc: {
        required,
      },
      recommendation_doc_no: {
        required,
      },
      // ftz_doc: {
      //   required,
      // },
      // ftz_doc_no: {
      //   required,
      // },
    },
  },
  mounted() {
    // this.getData(this.currentPage);
    this.withdrawal_id = this.$route.params.id;
    this.role = sessionStorage.getItem("role");

    let url;
    if (this.role == 5) {
      url = "/v2/clearing/operator/get/detail/deposit/" + this.withdrawal_id;
    } else if (this.role == 2 || this.role == 3 || this.role == 7) {
      url = "/v2/clearing/admin/abx/get/detail/deposit/" + this.withdrawal_id;
    } else if (this.role == 1) {
      url = "/v2/clearing/admin/get/detail/deposit/" + this.withdrawal_id;
    }

    axios.get(url).then((res) => {
      this.dataDetail = res.data.data.body;
      this.dataHolding = res.data.data.holdings;
      this.dataNasabah = res.data.data.nasabah;
      this.deposit_status = res.data.data.body.status;
      this.deposit_type = res.data.data.body.type;

      for (let i = 0; i < this.dataDetail.length; i++) {
        this.form.allocated = this.dataDetail[i].allocated;
        this.form.hub = this.dataDetail[i].hub;
        this.form.dimension = this.dataDetail[i].dimension;
        this.form.fineness = this.dataDetail[i].fineness;
        this.form.hallmark = this.dataDetail[i].hallmark;
        this.form.serial_number = this.dataDetail[i].serial_number;
        this.form.year = this.dataDetail[i].year;
      }
    });
  },
  computed: {
    depositDetail() {
      return this.dataDetail;
    },
    detailItemMetal() {
      return this.dataDetail.deposit_detail;
    },
    filteredAnalysisDocuments() {
      return this.getFilteredDocuments("analysis_doc");
    },
    filteredDepositDocuments() {
      return this.getFilteredDocuments("deposit_doc");
    },
  },
  methods: {
    addMetalDeposit() {
      let dataMetals = JSON.parse(sessionStorage.getItem("metalAdd"));

      let totalWeight = 0;
      for (let i = 0; i < dataMetals.length; i++) {
        totalWeight += dataMetals[i].weight;
      }

      if (totalWeight < this.dataDetail.deposit_detail.total_weight) {
        this.$toast.error("Metal less than total weight");
      } else {
        this.loadingDeposite = true;
        this.$store.dispatch("getLocation").then((resGeo) => {
          let info;
          if (resGeo.cityData[0]) {
            info = JSON.stringify(resGeo);
          } else {
            let data = resGeo;
            data.newLatLong = resGeo.cityLatLong.split(",");
            info = JSON.stringify(data);
          }

          let dataSubmit = {
            info: info,
            status: "004",
            _id: this.withdrawal_id,
            metals: dataMetals,
          };
          axios
            .put("/v2/clearing/operator/offexchange/deposit/update", dataSubmit)
            .then((res) => {
              if (res.status == 200) {
                this.loadingDeposite = false;
                this.$toast.success(
                  "The deposit has been successfully processed"
                );
                sessionStorage.removeItem("metalAdd");
                setTimeout(function () {
                  location.reload();
                }, 3000);
              }
            })
            .catch((err) => {
              this.loadingDeposite = false;
              this.$toast.error(err.response.data.message);
            });
        });
      }
    },
    getFilteredDocuments(docType) {
      let docs = this.dataDetail.attachments.event_report_doc[docType] || [];
      let activeDocs = docs.filter((doc) => doc.isActive);
      activeDocs.sort((a, b) => new Date(b.date) - new Date(a.date));
      return activeDocs.length > 0 ? [activeDocs[0]] : [];
    },
    addDocNews() {
      let dataDoc = {
        _id: this.withdrawal_id,
        doc_type: "",
        doc_url: "",
      };

      console.log(dataDoc);
    },
    modalOpen(event) {
      this.isModalOpen = event;
      this.$refs["add-attactment"].show();
    },
    openPreview(file, label) {
      this.$refs["preview-modal"].show();
      this.labelPreview = label;
      this.isLoadingPreview = true;
      let newFile = file.replace("/kmi", "/vms");
      this.getImage(newFile)
        .then((res) => {
          if (file.split(".").pop() == "pdf") {
            this.isPdf = true;
            this.isLoadingPreview = false;
            // this.src = pdf.createLoadingTask(res);
            // this.src.promise.then((pdf) => {
            //   this.numPages = pdf.numPages;
            // });
          } else {
            this.isLoadingPreview = false;
            this.isPdf = false;
            this.src = res;
          }
        })
        .catch(() => {
          this.isLoadingPreview = false;
        });
    },
    async getImage(file) {
      let image = await axios.get(this.url + file, { responseType: "blob" });
      image = URL.createObjectURL(
        new Blob([image.data], { type: image.data.type })
      );
      return image;
    },
    handlePageChange(value) {
      this.getData(value);
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    showModalOperator(id, status) {
      this.status_operator = status;
      this.metal_id = id;
      this.$refs["modal-operator"].show();
    },

    hideModalOperator() {
      this.$refs["modal-operator"].hide();
    },

    operatorKonfirmation() {
      this.loadingOperatorConfirm = true;
      let value;
      if (this.status_operator == 1) {
        value = "accept";
      } else {
        value = "reject";
      }
      // console.log(value);
      axios
        .put("/v1/clearing/operator/metal/confirmation/" + this.metal_id, {
          option: value,
        })
        .then((res) => {
          if (res.status == 200) {
            this.loadingOperatorConfirm = false;
            this.$toast.success(res.data.message);
            setTimeout(function () {
              location.reload();
            }, 3000);
          }
        })
        .catch((err) => {
          this.loadingOperatorConfirm = false;
          this.$toast.error(err.response.data.message);
        });
    },
    submitMetal() {
      this.loadingMetal = true;
      axios
        .put("/v1/clearing/admin/abx/metal/" + this.metal_id, this.form)
        .then((res) => {
          if (res.status == 200) {
            this.loadingMetal = false;
            this.$toast.success(res.data.message);
            setTimeout(function () {
              location.reload();
            }, 3000);
          }
        })
        .catch((error) => {
          this.loadingMetal = false;
          this.$toast.error(error.response.data.message);
        });
    },
    addAttachment() {
      this.$v.form_attachment.$touch();
      if (this.$v.form_attachment.$error) {
        this.loadingDeposite = false;
        return;
      }
      this.loadingDeposite = true;
      this.form_attachment.metal_id = this.withdrawal_id;
      axios
        .post("/v2/clearing/operator/update_attachment", this.form_attachment)
        .then((res) => {
          if (res.data.data.status_code == "00") {
            this.loadingDeposite = false;
            this.$toast.success("Add Attachment Success");
            setTimeout(function () {
              location.reload();
            }, 3000);
          }
        });
    },
    processDeposite() {
      this.loadingDeposite = true;

      let url;
      if (this.deposit_type == "onexchange") {
        if (this.role == 2 || this.role == 3) {
          url = "/v2/clearing/admin/abx/deposit/confirmation";
          this.hitUrlDeposit(url);
        } else if (this.role == 5) {
          url = "/v2/clearing/operator/deposit/confirmation";
          this.hitUrlDeposit(url);
        } else {
          url = "/v2/clearing/admin/deposit/confirmation";
          this.hitUrlDeposit(url);
        }
      } else {
        if (
          (this.role == 2 || this.role == 3) &&
          (this.dataDetail.status == "001" || this.dataDetail.status == "007")
        ) {
          if (this.dataDetail.status == "001") {
            this.statusDeposit = "002";
          } else {
            this.statusDeposit = "003";
          }
          url = "/v2/clearing/admin/abx/offexchange/deposit/update";
          this.hitUrlDeposit(url);
        } else if (this.role == 5) {
          url = "/v2/clearing/operator/offexchange/deposit/update";
          this.hitUrlDeposit(url);
        } else {
          for (let i = 0; i < this.dataDetail.metal_info.length; i++) {
            console.log(
              this.dataDetail.metal_info[i].status == "003" &&
                this.dataDetail.metal_info[i].revision == false
            );
            console.log(this.dataDetail.metal_info[i]);
            if (
              this.dataDetail.metal_info[i].status == "003" &&
              this.dataDetail.metal_info[i].revision == false
            ) {
              this.statusDeposit = "006";
              break;
            } else {
              this.statusDeposit = "004";
            }
          }
          const newSubmit = this.dataDetail.metal_info.find(
            (element) => element.status == "001"
          );

          if (newSubmit) {
            this.$toast.error("Metal not updated");
            this.loadingDeposite = false;
          } else {
            url = "/v2/clearing/admin/abx/offexchange/deposit/confirmation";
            this.hitUrlDeposit(url);
          }
        }
      }
    },
    rejectDeposit() {
      this.isRejectDeposit = true;
      this.statusDeposit = "009";
      this.hitUrlDeposit("/v2/clearing/admin/abx/offexchange/deposit/update");
    },
    hitUrlDeposit(url) {
      this.$store.dispatch("getLocation").then((resGeo) => {
        let info;
        if (resGeo.cityData[0]) {
          info = JSON.stringify(resGeo);
        } else {
          let data = resGeo;
          data.newLatLong = resGeo.cityLatLong.split(",");
          info = JSON.stringify(data);
        }

        let data;

        if (this.deposit_type == "onexchange") {
          data = {
            _id: this.withdrawal_id,
            info: info,
          };
        } else {
          data = {
            _id: this.withdrawal_id,
            status: this.statusDeposit,
            info: info,
          };
        }
        axios
          .put(url, data)
          .then((res) => {
            if (res.status == 200) {
              this.loadingDeposite = false;
              this.isRejectDeposit = false;
              if (this.statusDeposit == "009") {
                this.$toast.success("The Deposit Has been Rejected");
              } else {
                this.$toast.success(
                  "The deposit has been successfully processed"
                );
              }
              setTimeout(function () {
                location.reload();
              }, 3000);
            }
          })
          .catch((err) => {
            this.loadingDeposite = false;
            this.$toast.error(err.response.data.message);
          });
      });
    },
    apprveKBI() {
      this.loadingKbi = true;
      axios
        .put("/v1/clearing/admin/deposit/confirmation" + this.withdrawal_id)
        .then((res) => {
          if (res.status == 200) {
            this.loadingKbi = false;
            this.$toast.success(res.data.message);
            setTimeout(function () {
              location.reload();
            }, 3000);
          }
        })
        .catch((err) => {
          this.loadingKbi = false;
          this.$toast.error(err.response.data.message);
        });
    },
    // onFileChange(formInput, label, ref, loadData) {
    //   console.log(formInput, label, ref, loadData);
    //   this[loadData] = true;
    //   const fileInput = this.$refs[ref].files[0];
    //   if (fileInput.type == "image/jpeg" || fileInput.type == "image/jpg" || fileInput.type == "image/png" || fileInput.type == "application/pdf") {
    //     this.requestFormData(fileInput).then((res) => {
    //       this[loadData] = false;
    //       this[label] = fileInput.name;
    //       this[formInput] = res.data.data;
    //       console.log(this.form_attachment);
    //     });
    //     return this[loadData], this[label], this[formInput];
    //   }
    // },
    onCustomDoc() {
      this.loadDataCustomDoc = true;
      const fileCustomDoc = this.$refs.customsDoc.files[0];
      if (
        fileCustomDoc.type == "image/jpeg" ||
        fileCustomDoc.type == "image/jpg" ||
        fileCustomDoc.type == "image/png" ||
        fileCustomDoc.type == "application/pdf"
      ) {
        this.requestFormData(fileCustomDoc).then((res) => {
          this.loadDataCustomDoc = false;
          this.label_custom = fileCustomDoc.name;
          this.form_attachment.customs_doc = res.data.data;
        });
      }
    },
    onInvoice() {
      const fileInvoice = this.$refs.invoice.files[0];
      this.loadDataInvoice = true;
      if (
        fileInvoice.type == "image/jpeg" ||
        fileInvoice.type == "image/jpg" ||
        fileInvoice.type == "image/png" ||
        fileInvoice.type == "application/pdf"
      ) {
        this.requestFormData(fileInvoice).then((res) => {
          this.loadDataInvoice = false;
          this.label_invoice = fileInvoice.name;
          this.form_attachment.commercial_invoice = res.data.data;
        });
      }
    },
    onManfacturing() {
      this.loadDataManu = true;
      const fileManuFacturing = this.$refs.manufactur.files[0];
      if (
        fileManuFacturing.type == "image/jpeg" ||
        fileManuFacturing.type == "image/jpg" ||
        fileManuFacturing.type == "image/png" ||
        fileManuFacturing.type == "application/pdf"
      ) {
        this.requestFormData(fileManuFacturing).then((res) => {
          this.loadDataManu = false;
          this.label_manufacturing = fileManuFacturing.name;
          this.form_attachment.manufacturing_doc = res.data.data;
        });
      }
    },
    onVault() {
      this.loadDataVault = true;
      const fileVault = this.$refs.vault.files[0];
      if (
        fileVault.type == "image/jpeg" ||
        fileVault.type == "image/jpg" ||
        fileVault.type == "image/png" ||
        fileVault.type == "application/pdf"
      ) {
        this.requestFormData(fileVault).then((res) => {
          this.loadDataVault = false;
          this.label_vault = fileVault.name;
          this.form_attachment.vault_doc = res.data.data;
        });
      }
    },
    onClearing() {
      this.loadDataClearing = true;
      const fileClearing = this.$refs.clearing.files[0];
      if (
        fileClearing.type == "image/jpeg" ||
        fileClearing.type == "image/jpg" ||
        fileClearing.type == "image/png" ||
        fileClearing.type == "application/pdf"
      ) {
        this.requestFormData(fileClearing).then((res) => {
          this.loadDataClearing = false;
          this.label_clearing = fileClearing.name;
          this.form_attachment.clearing_doc = res.data.data;
        });
      }
    },
    onBpBatam() {
      this.loadDataBpbatam = true;
      const fileBpBatam = this.$refs.bpBatam.files[0];
      if (
        fileBpBatam.type == "image/jpeg" ||
        fileBpBatam.type == "image/jpg" ||
        fileBpBatam.type == "image/png" ||
        fileBpBatam.type == "application/pdf"
      ) {
        this.requestFormData(fileBpBatam).then((res) => {
          this.loadDataBpbatam = false;
          this.label_bpbatam = fileBpBatam.name;
          this.form_attachment.recommendation_doc = res.data.data;
        });
      }
    },
    onBeaCukai() {
      this.loadDataCukai = true;
      const fileFtz = this.$refs.beaCukai.files[0];
      if (fileFtz.type == "application/pdf") {
        this.requestFormData(fileFtz).then((res) => {
          this.loadDataCukai = false;
          this.label_cukai = fileFtz.name;
          this.form_attachment.ftz_doc = res.data.data;
        });
      } else {
        this.$toast.error("File type must be .pdf");
        this.loadDataCukai = false;
      }
    },
    requestFormData(fileData) {
      let formData = new FormData();
      formData.append("file", fileData);
      return axios.post("/v2/upload", formData);
    },

    download() {
      this.isLoading = true;
      var data = document.getElementById("document-confirmation");
      var name = "document-confirmation.pdf";

      // var canvasElement = document.createElement("canvas");

      html2canvas(data, { useCORS: true, scale: 2 }).then((canvas) => {
        var margin = 7;
        var imgWidth = 210 - 2 * margin;
        var pageHeight = 295;
        var imgHeight = (canvas.height * imgWidth) / canvas.width;
        var heightLeft = imgHeight;
        let img = canvas.toDataURL("image/png");
        let pdf = new jsPDF("p", "mm", "A4");
        var position = 0;
        pdf.addImage(img, "PNG", margin, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
        while (heightLeft >= 0) {
          position = heightLeft - imgHeight;
          pdf.addPage();
          pdf.addImage(img, "PNG", margin, position, imgWidth, imgHeight);
          heightLeft -= pageHeight;
        }
        pdf.save(name);
        this.isLoading = false;
      });
    },
  },
};
</script>

<style scoped>
/*.wrap-dashboard {
  min-height: 100vh;
  margin: 0;
  display: grid;
  grid-template-rows: auto 1fr auto;
}*/

.error {
  font-size: 12px;
  color: #f5365c;
}

.upload-video {
  border: 1px solid #1f354a;
  padding: 0.5rem;
  color: #1f354a;
  border-radius: 5px;
  font-size: 12px;
  cursor: pointer;
  font-weight: bold;
}

.upload-video:hover {
  background: #1f354a;
  color: #ffffff;
}

.icon-upload {
  font-size: 13px;
}

#inputTag {
  display: none;
}

input[type="file"] {
  display: none;
}

.form-input {
  width: 50%;
  border-radius: 5px;
  border: none;
  padding: 0.5rem 1rem;
  box-shadow: 0 1px 3px rgb(50 50 93 / 15%), 0 1px 0 rgb(0 0 0 / 2%);
}

.form-input:focus {
  border-color: var(--clr-primary);
  outline: 0;
  box-shadow: 0 1px 3px rgb(50 50 93 / 15%), 0 1px 0 rgb(0 0 0 / 2%);
}

.fa-check {
  color: #28a745;
  cursor: pointer;
}
.fa-times {
  color: #dc3545;
  cursor: pointer;
}

.title-page {
  font-size: 25px;
  font-weight: bold;
  margin-bottom: 40px;
}

.form-group {
  margin-bottom: 1.7rem;
}

.form-attachment .form-input {
  width: 100%;
}

.content-ftz-doc {
  display: flex;
  width: 100%;
  gap: 2rem;
}

.content-ftz-doc div {
  width: 100%;
}

.label-ftz {
  display: block;
  width: 100%;
  font-weight: 500;
  font-size: 13px;
}

.label-form {
  display: block;
  width: 100%;
  font-weight: bold;
}

input {
  font-size: 13px;
}

.buuton-add {
  text-align: right;
  font-size: 13px;
}

.content {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  justify-content: flex-end;
  margin-top: 15px;
}

.icon-trade {
  width: 25px;
}

.footer {
  background: var(--clr-primary);
  color: white;
  padding: 20px 47px;
  display: flex;
  justify-content: space-between;
  margin-top: auto;
  height: 62px;
}

.filter {
  display: table-cell;
  width: 20%;
  font-size: 12px;
}
.wrap-input {
  display: flex;
}

select {
  width: 130px;
  border-radius: 3px;
  border-color: #a5a5a5a5;
  padding: 3px;
}

.card {
  width: 314px;
  font-size: 14px;
  border-radius: 10px;
}

.card-header {
  padding: 1rem;
}

.buyer,
.seller,
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.title {
  font-size: 12px;
  position: relative;
  left: 20px;
}

.title::before {
  content: "";
  position: absolute;
  width: 11px;
  height: 11px;
  border-radius: 50%;
  background: var(--clr-scondary);
  left: -17px;
  top: 3px;
}

.buyer {
  margin-bottom: 20px;
}

.amount {
  font-weight: bold;
}

.status-allocated {
  font-weight: 600;
  color: #2dce89;
}

.status-processed {
  font-weight: 600;
  color: rgb(172, 143, 26);
}

.status-rejected {
  font-weight: 600;
  color: #f5365c;
}

.warning-file {
  font-weight: 500;
}
</style>
